<template>
	<h2 class="text-left lg:m-auto lg:py-6 lg:text-center xl:w-1/2">
		{{ heading }}
	</h2>
	<div
		class="text-left text-lg text-gray-575 lg:m-auto lg:w-1/2 lg:text-center"
	>
		{{ subHeading }}
	</div>
	<div class="flex flex-col items-center justify-center">
		<div class="flex flex-col justify-center lg:flex-row">
			<div class="flex w-full flex-col">
				<div class="relative mt-16 flex flex-col">
					<div class="flex flex-col justify-center">
						<h3 class="font-body font-medium">01.</h3>
						<h3 class="font-body font-medium">
							Create an account for free
						</h3>
						<div class="mt-2 space-y-4 text-lg text-gray-575">
							Once you’re set-up, you can create a wishlist and
							subscribe at any time.
						</div>

						<IconSellYourCar1
							class="absolute -bottom-5 right-0 text-gray-500 lg:-bottom-10"
						/>
						<div v-if="!isListingOnly" class="mt-5">
							<CarbarLink :href="'/sign-up'">
								<CarbarButton
									is-silent-filter
									:is-full-width="false"
									:is-outline="true"
								>
									Join for free now
								</CarbarButton>
							</CarbarLink>
						</div>
					</div>
				</div>
				<div class="relative mt-16 flex flex-col lg:mt-32">
					<h3 class="font-body text-xl font-medium">02.</h3>
					<h3 class="font-body font-medium">
						Shop and subscribe, all online
					</h3>
					<div class="mt-2 space-y-4 text-lg text-gray-575">
						New cars are added every day. Simply pay the upfront fee
						to submit your order.
					</div>
					<IconSellYourCar2
						class="absolute -bottom-5 right-0 text-gray-500 lg:-bottom-10"
					/>
					<div class="mt-5">
						<CarbarLink href="/cars/subscribe" :underline="false">
							<CarbarButton :is-full-width="false">
								Browse cars
							</CarbarButton>
						</CarbarLink>
					</div>
				</div>
			</div>
			<div
				class="order-first mt-16 flex w-full flex-col items-center justify-center lg:order-none"
			>
				<CarbarImage
					image-width-class="md:w-1/2 lg:w-full"
					image="img/car-subscription/img-pd-subs.webp"
					alt-text="Pick up your car"
				/>
			</div>
			<div class="flex w-full flex-col">
				<div class="relative mt-16 flex flex-col">
					<h3 class="font-body text-xl font-medium">03.</h3>
					<h3 class="font-body font-medium">
						Pick it up at your local carbar office
					</h3>
					<div class="mt-2 space-y-4 text-lg text-gray-575">
						You can schedule a convenient time to collect the
						vehicle from our offices in Sydney, Brisbane, or
						Melbourne.
					</div>
					<IconSellYourCar3
						class="absolute -bottom-5 right-0 text-gray-500 lg:-bottom-10"
					/>
				</div>
				<div class="relative mt-16 flex flex-col lg:mt-32">
					<h3 class="font-body text-xl font-medium">04.</h3>
					<h3 class="font-body font-medium">Stop or swap anytime</h3>
					<div class="mt-2 space-y-4 text-lg text-gray-575">
						Just give us 2 weeks notice to swap or stop your
						subscription.
					</div>
					<IconSellYourCar4
						class="absolute -bottom-16 right-0 text-gray-500 lg:-bottom-10"
					/>
				</div>
			</div>
		</div>
		<div class="mt-4 text-xl font-medium">
			Take the hassle, stress and uncertainty out of having a car.
		</div>
		<div class="w-full lg:w-auto">
			<CarbarLink href="/cars/subscribe" :underline="false">
				<CarbarButton
					class="mt-5"
					:is-full-width="false"
					:border-color="'text-orange-400'"
				>
					Subscribe to carbar today
				</CarbarButton>
			</CarbarLink>
		</div>
		<TermsAndConditions>
			<div>
				^ In certain circumstances we may need to swap your car (e.g. if
				there is a maintenance or other issue) – in which case we will,
				subject to availability, try to replace the car with an
				equivalent car.
				<CarbarLink
					:font-size="'text-xsm'"
					:href="'/terms-and-conditions/car-subscription'"
					text="Terms and conditions"
					target="_blank"
				/>
				apply.
			</div>
		</TermsAndConditions>
	</div>
</template>

<script setup>
import CarbarImage from '@/components/CarbarImage.vue'
import CarbarButton from '@/components/buttons/CarbarButton.vue'
import CarbarLink from '@/components/links/CarbarLink.vue'
import TermsAndConditions from '@/components/fineprint/TermsAndConditions.vue'
import IconSellYourCar1 from '@/assets/svg/sell-your-car/sell-your-car-1.svg'
import IconSellYourCar2 from '@/assets/svg/sell-your-car/sell-your-car-2.svg'
import IconSellYourCar3 from '@/assets/svg/sell-your-car/sell-your-car-3.svg'
import IconSellYourCar4 from '@/assets/svg/sell-your-car/sell-your-car-4.svg'

const props = defineProps({
	heading: {
		type: String,
		default: 'How does a car subscription service work?',
		required: false,
	},
	subHeading: {
		type: String,
		default:
			'With carbar, it’s easy. Simply shop and subscribe to your next car all online. There’s no commitment. Cancel anytime with two weeks notice.',
		required: false,
	},
})

const isListingOnly = useIsListingOnly()
</script>
